import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'projects/foreign-admits/src/environments/environment';

import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { F1GtmService } from 'projects/apna-lib/src/lib/services/f1-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import { RazorpayService } from 'projects/apna-lib/src/lib/services/razorpay.service';
import { reject } from 'lodash';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  COVENTRY_ORIGIN,
  COVENTRY_INBOUND_EVENTS,
  COVENTRY_OUTBOUND_EVENTS,
} from '../../../constants/coventry-integration.constants';
declare var EmbeddableWidget: any;
@Component({
  selector: 'fa-overall-user-dashboard',
  templateUrl: './overall-user-dashboard.component.html',
  styleUrls: ['./overall-user-dashboard.component.scss'],
})
export class OverallUserDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('disclaimerPopup') disclaimerPopup: TemplateRef<any>;
  @ViewChild('insightInterviewModal') insightInterviewModal: TemplateRef<any>;
  @ViewChild('offerCodePopup') offerCodePopup: TemplateRef<any>;
  active = 0;
  showAlert: boolean = true;
  activeId: string = 'overview';
  paymentDataModel: any = 'payments/licence-mock-visa';
  paymentVerifyDataModel: any = 'payments/licence-mock-visa/signature-verify';
  updateLicenceModel: any = 'partner-licences/update';
  currentInterview: any;
  razorpayConfig: any;
  isPartnerLink: boolean = false;
  partnerLogo: string;
  licenseDetails: any;
  overallperformance: number;
  visaInterviewDate: any;
  averageVisaScore: number;
  averageCommunication: number;
  averageBodyLanguage: number;
  userDetails: any;
  testNames: any = [];
  scenarios: any = [];
  visaInterviewStatus: any;
  graphData: any = {};
  puid: string;
  auth: any = '';
  step: string = 'firstStep';
  loadingBtn: boolean = true;
  loading: boolean = false;
  codeExpiry: number;
  selectedInterview: any = {};
  visaInformation: any;
  mockInterviews: any;
  avansePuidEnable: boolean = false;
  mockvisaInterviewPlansOptions: any;
  visamonkPermissions: any;
  partnerUidDetails: any;
  private activityInterval: any;
  private lastActivitySent: Date = new Date();
  private sessionCheckInterval: any
  // private isIntentionalReload: boolean = false;

  // --- Coventry integration ---
  showCoventryIframe: boolean = false;
  coventryIframeUrl: SafeResourceUrl = '';
  private coventryPayload: any = null;
  private coventryMessageListener: ((event: MessageEvent) => void) | null = null;
  // Origin the Coventry iframe is actually loaded from - derived from interviewLink
  // (not the COVENTRY_ORIGIN constant) so the postMessage origin check still matches
  // when interviewLink is rewritten for local testing.
  private coventryOrigin: string = COVENTRY_ORIGIN;
  // ----------------------------

  countryOfCizenshipOptions = this.configService.getConfig1("foreignAssist", "countryOfCizenshipOptions");

  dummyTokenGenerationEmail = this.configService.getConfig1("foreignAssist", "dummyTokenGenerationEmail");

  navbarData: any = {
    isPartnerLink: this.isPartnerLink,
    partnerLogo: undefined,
    ngbNav: true,
    setActiveTab: this.activeId,
    help: true,
    visaMonkExpires: false,
    codeExpiry: 0,
    logout: true
  };



  partnerLogoLink: string;

  // Offer code popup properties
  offerCodeFields: FormlyFieldConfig[];
  offerCodeModel: any = {};
  offerCodeValidationMessage: boolean = false;
  offerCodeSuccessMessage: boolean = false;

  // Store offer information for payment success
  appliedOfferCode: string = '';
  discountedPricePaid: number = 0;
  originalAmount: number = 0;

  // UI display properties for pricing
  currentOriginalPrice: number = 0;
  currentDiscountedPrice: number = 0;
  currentDiscountPercent: number = 0;
  showDiscountedPrice: boolean = false;
  loadingCoventryIframe: boolean = false;

  constructor(
    private visaService: F1GtmService,
    private route: Router,
    private apiHelper: ApiHelperService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private userIdentity: UserIdentityService,
    private configService: ConfigService,
    private modalService: NgbModal,
    private razorPay: RazorpayService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    console.info("Navigated to Overall Dashboard")
    const puid = this.activatedRoute?.snapshot?.params.puid;
    this.puid = puid;
    this.loadPermissions();


    if (this.puid) {
      localStorage.setItem('puid', puid);
    }

    this.checkUserLoggedIn();

    if (this.puid === environment?.avansePuid) {
      this.avansePuidEnable = true;
    } else {
      this.avansePuidEnable = false;
    }

    if (localStorage?.getItem('goBackToDashboard')) {
      this.activeId = 'my-tests';
      localStorage.removeItem('goBackToDashboard');

      this.navbarData = {
        ...this.navbarData,
        setActiveTab: this.activeId
      };
    }

    // this.startActivityTracking();
    // this.addBrowserCloseDetection();
  }

  checkUserLoggedIn() {
    // Skip token validation for avansePuid flow
    if (this.puid === environment.avansePuid) {
      return;
    }
    else {
      if (!this.userIdentity.isValidToken()) {
        this.userIdentity.clearUserDetails();
        if (this.puid) {
          this.route.navigate(['/' + this.puid]);
        } else {
          this.route.navigate(['/']);
        }
        return;
      }
    }
  }


  private async loadPermissions(): Promise<void> {
    try {
      this.visamonkPermissions = await this.configService.getKeyConfiguration('visamonkPermissions');
      this.mockvisaInterviewPlansOptions = await this.configService.getKeyConfiguration("mockvisaInterviewPlans")

    } catch (error) {
      console.error('Error loading permissions:', error);
      this.loading = false;
    }

    this.licenceInformationDetails();


  }

  changeActiveId(tab: string) {
    this.activeId = tab;
  }

  getCountryLabel(countryCode: string): string {
    const country = this.countryOfCizenshipOptions.find(option => option.value === countryCode);
    return country ? country.label : countryCode; // fallback to code if label not found
  }


  licenceInformationDetails() {

    let interviewCode = localStorage.getItem('visaCode');
    const apiEndpoint = `partner-licences/by-licence-number/${interviewCode}`;
    this.apiHelper.getData(apiEndpoint).then((data: any) => {
      this.licenseDetails = data;
      const filter = {
        where: {
          _id: this.licenseDetails?.studentId
        }
      };
      this.apiHelper.getData('user', filter).then((res: any) => {
        this.userDetails = res?.users?.[0];
        this.getInterviewPlan();
        this.loadingBtn = false;
        this.getVisaInterviewDate();
      });

    })
  }

  async getInterviewPlan() {
    let plan = this.mockvisaInterviewPlansOptions[this.puid];
    let country = this.userDetails?.targetCountry || 'US';
    let filter = {
      where: {
        plan: plan,
        visaStatus: this.visaInformation?.visaDetails?.visaStatus,
        degree: this.userDetails?.targetDegree.toLowerCase(),
      }
    };
    const plans: any = await this.apiHelper.getData('mock-interview-plans', filter);

    const filteredInterviews = plans?.data?.filter(interview => {
      return interview.countryWiseRoleKey &&
        interview.countryWiseRoleKey[country] &&
        interview.countryWiseRoleKey[country].roleKey;
    });

    const uniqueInterviews = filteredInterviews?.reduce((acc, current) => {
      const key = `${current.title}-${current.difficulty}`;
      if (!acc.find(item => `${item.title}-${item.difficulty}` === key)) {
        acc.push(current);
      }
      return acc;
    }, []);

    this.mockInterviews = uniqueInterviews?.sort((a, b) => {
      const difficultyOrder = { 'easy': 1, 'medium': 2, 'hard': 3 };
      const diffA = difficultyOrder[a.difficulty?.toLowerCase()] || 999;
      const diffB = difficultyOrder[b.difficulty?.toLowerCase()] || 999;
      if (diffA !== diffB) {
        return diffA - diffB;
      }
      return a.title.localeCompare(b.title);
    });

    await this.getInterviewCodeDetails(this.licenseDetails?.licenceNumber);
  }


  async getInterviewCodeDetails(visaCode: any) {
    const apiEndpoint = `partner-licences/by-licence-number/${visaCode}`;
    if (this.licenseDetails) {
      let totalScore = 0;
      let totalCommunication = 0;
      let totalBodyLanguage = 0;
      let totalVisaScore = 0;
      let count = 0;

      this.apiHelper.getData(apiEndpoint).then((res: any) => {
        for (let single of res?.webhookRes) {
          if (
            single?.score &&
            single?.communication &&
            single?.body_language &&
            single?.visa_score
          ) {
            const score = Number(single.score) || 0;
            const communication = Number(single.communication) || 0;
            const bodyLanguage = Number(single.body_language) || 0;
            const visaScore = Number(single.visa_score) || 0;
            totalScore += score;
            totalCommunication += communication;
            totalBodyLanguage += bodyLanguage;
            totalVisaScore += visaScore;
            count++;
          }
          this.scenarios.push(single);
        }

        this.scenarios.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        this.scenarios[0].isLatest = true;

        const roundAttemptMap = new Map<string, any[]>();

        this.scenarios.forEach((scenario) => {
          const roundName = scenario.Round.trim().toLowerCase();
          if (!roundAttemptMap.has(roundName)) {
            roundAttemptMap.set(roundName, []);
          }
          roundAttemptMap.get(roundName).push(scenario);
        });

        roundAttemptMap.forEach((group) => {
          group
            .sort(
              (a, b) =>
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime()
            )
            .forEach((item, index) => {
              item.attemptNumber = index + 1;
            });
        });

        this.overallperformance =
          count > 0 ? +(totalScore / count).toFixed(2) : 0;

        this.averageVisaScore =
          count > 0 ? +(totalVisaScore / count).toFixed(2) : 0;
        this.averageCommunication =
          count > 0 ? +(totalCommunication / count).toFixed(2) : 0;
        this.averageBodyLanguage =
          count > 0 ? +(totalBodyLanguage / count).toFixed(2) : 0;

        this.graphData = [
          {
            averageVisaScore: this.averageVisaScore,
            averageCommunication: this.averageCommunication,
            averageBodyLanguage: this.averageBodyLanguage,
          },
        ];

        const startDate = new Date();
        const endDate = new Date(res?.end_date);

        endDate.setHours(23, 59, 59, 999);

        const differenceInMs: number = endDate.getTime() - startDate.getTime();
        const millisecondsInDay: number = 1000 * 60 * 60 * 24;
        this.codeExpiry = Math.floor(differenceInMs / millisecondsInDay);

        this.navbarData = {
          ...this.navbarData,
          visaMonkExpires: true,
          codeExpiry: this.codeExpiry
        };


        if (this.codeExpiry < 0) {
          this.codeExpiry = 0;
          this.loadingBtn = true;
        }

        const countArray = this.mockInterviews.map((interview) => {
          const count = this.scenarios.filter(
            (item) =>
              item.Round.trim().toLowerCase() ===
              interview.title.trim().toLowerCase()
          ).length;
          return { title: interview?.title.trim(), remainingAttempts: count };
        });

        this.mockInterviews = this.mockInterviews.map((interview) => {
          const match = countArray.find(
            (count) =>
              count.title.trim().toLowerCase() ===
              interview.title.trim().toLowerCase()
          );
          return {
            ...interview,
            remainingAttempts: match ? match.remainingAttempts : 0,
          };
        });
      });
    }
  }

  viewInsights(scenario: any) {
    localStorage.setItem('scenario', JSON.stringify(scenario));
    if (this.puid) {
      this.route.navigate(['test-dashboard/' + `${this.puid}`]);
    } else {
      this.route.navigate(['test-dashboard']);
    }
  }

  async getPartnerDetails(partnerUid: string): Promise<void> {
    try {
      // Use new secure public API endpoint - no authentication needed
      const response: any = await this.apiHelper.getData(`user/partner-details/${partnerUid}`);

      if (response?.success && response?.partner) {
        const partnerDetails = response.partner;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
        this.partnerLogoLink = partnerDetails?.company?.logo;

        this.navbarData = {
          ...this.navbarData,
          partnerLogo: this.partnerLogoLink
        };
      } else {
        this.isPartnerLink = false;
      }
    } catch (error) {
      console.error('Error loading partner details:', error);
      this.isPartnerLink = false;
      throw error;
    }
  }


  getPartnerDetailedInfo(partnerUid) {
    this.apiHelper.getDataById("user/by-uid", partnerUid).subscribe((response: any) => {
      this.partnerUidDetails = { ...response?.user };
    })
  }

  openDisclaimer(interview: any) {
    let country = this.userDetails?.targetCountry;
    let roleKey = interview.countryWiseRoleKey?.[country]?.roleKey || '';
    let roundKey = interview.countryWiseRoleKey?.[country]?.roundKey || '';
    this.selectedInterview = {
      ...interview,
      roleKey,
      roundKey,
    };

    this.modalService.open(this.disclaimerPopup, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'xl',
    });
  }

  openInsightInterviewPopup() {
    this.modalService.open(this.insightInterviewModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'm',
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  closeAlert() {
    this.showAlert = false;
  }

  goToInstruction() {
    this.step = 'secondStep';
  }

  goBack() {
    if (this.step === 'secondStep') {
      this.step = 'firstStep';
    } else {
      this.modalService.dismissAll();
    }
  }

  takeTheInterview(interview: any) {
    console.info(interview);
    let sourceOfFinding = this.visaInformation?.visaDetails?.visaFinancialStatus.join(',');
    const headers = new HttpHeaders({
      authentication: environment.visainterviewkey,
    });
    const body = {
      user_id: this.userDetails?._id,
    };
    this.http.post(environment.ramestoStartTestUrl, body, { headers: headers }).subscribe((res: any) => {
      this.modalService.dismissAll();
      this.step = 'firstStep';
      this.auth = res?.data?.token;
      EmbeddableWidget.mount({
        test: true, // for Testing/Production environment true or false
        email: 'test@gmail.com', // (Optional)
        user_id: this.userDetails?._id, // provided by client (Required),
        auth_token: this.auth, // this will you get from above API (Required),

        role_key: interview?.roleKey,
        round_key: interview?.roundKey,
        extraInfo: JSON.stringify({
          target_country: this.userDetails?.targetCountry,
          university: this.userDetails?.academicDetails?.university,
          target_degree: this.userDetails?.targetDegree,
          specialization: this.userDetails?.visaCourse,
          intake: this.userDetails?.targetIntake,
          visa_slot_info: this.visaInformation?.visaDetails?.visaInterviewStatus,
          fresh_or_rejected_visa: this.visaInformation?.visaDetails?.visaStatus,
          source_of_funding: sourceOfFinding,
          visa_rejections_other_countries: this.visaInformation?.visaDetails?.rejectionVisaStatus,
          licenceNumber: this.licenseDetails?.interviewCode,
          years_experience: this.userDetails?.visaWorkExperience,
          country_of_citizenship: this.getCountryLabel(this.userDetails?.countryOfCitizenship),
          country_code: this.userDetails?.countryOfCitizenship,
          embassy_location: this.visaInformation?.visaDetails?.visaEmbassyLocation,
          version: 'v2'
        }),
        callback: (data) => {
          this.visaService.resetBeforeUnload();
          console.info('data after closed modal ', data);
          if (data?.status === 'completed') {
            // this.isIntentionalReload = true;
            if (this.puid) {
              this.route.navigate(['overall-dashboard/' + this.puid]);
            } else {
              this.route.navigate(['overall-dashboard']);
            }

            location.reload();


          } else if (
            data?.status === 'fail' &&
            data?.ERROR_CODE !== 'ERR_CLOSE_BTN_CLICK'
          ) {
            let obj = {
              api_user_id: data?.user_id,
              Round: interview?.title,
              createdAt: new Date(),
              status: data?.status,
              practice_key: data?.practice_id,
              error: data?.ERROR_CODE,
            };
            this.apiHelper
              .postData('partner-licences/update-webhook', obj)
              .subscribe((res: any) => {
                if (this.puid) {
                  this.route.navigate(['overall-dashboard/' + this.puid]);
                } else {
                  this.route.navigate(['overall-dashboard']);
                }
                location.reload();


              });
          }
          localStorage.setItem('goBackToDashboard', 'my-tests');
        },
      });
    });
  }
  logout(event: boolean) {
    if (event) {
      this.performLogout();
    }
  }

  redirectUrl() {
    this.modalService.dismissAll();
  }

  getVisaInterviewDate() {
    this.apiHelper.getData(`visa-informations/check-existing/${this.licenseDetails?.licenceNumber}`).then((res: any) => {
      this.visaInformation = res;
      this.visaInterviewStatus = res?.visaDetails?.visaStatus;
      if (this.visaInterviewStatus === 'firstTimeApplying') {
        this.visaInterviewStatus = 'Fresh Visa';
      } else if (this.visaInterviewStatus === 'visaRejected') {
        this.visaInterviewStatus = 'Rejected Visa';
      }
      this.visaInterviewDate = res?.visaDetails?.visaInterviewDate;

      this.getPartnerDetails(this.puid)
      this.getPartnerDetailedInfo(this.puid);
    });
  }

  onPayNow(amount: string) {

    if (this.visamonkPermissions?.[this.puid]?.offerAvailable === true) {
      this.openOfferCodePopup();
    }
    else {
      let postObj = {
        studentId: this.userDetails._id,
        planId: 'paymentMockVisaLicence',
        currency: this.licenseDetails?.paymentCurrency,
        amount: Number(amount),
        paymentStatus: 'Initiated',
        puid: this.puid,
        receipt: this.userDetails.name, //why we need name?
      };
      if (this.userDetails?.parentId) {
        postObj['partnerId'] = this.userDetails.parentId;
      }
      if (this.userDetails?.parentUserId) {
        postObj['partnerId'] = this.userDetails.parentId;
        postObj['partnerUserId'] = this.userDetails.parentUserId;
      }

      let validateAmountObj = {
        puid: this.puid,
        amount: amount
      }

      this.apiHelper.postData("payments/validate-amount", validateAmountObj).subscribe((res: any) => {
        if (res?.data?.isValid) {
          this.razorPay.createOrder(this.paymentDataModel, postObj).subscribe((data: any) => {
            this.currentInterview = data;
            this.razorPay.openPaymentCheckout(
              data,
              this.visaService.studentDetails,
              'MockVisa'
            );
          },
            (error: any) => {
              console.error(error.error.message);
              this.apiHelper.openSnackBar("Don't try to tempered the amount")
            }
          );
        }
        else {
          this.apiHelper.openSnackBar("Don't try to tempered the amount")
        }
      })
    }
  }


  @HostListener('window:payment.mockVisa.success', ['$event'])
  onPaymentSuccess(event): void {
    let orderObj = {
      razorpayPaymentId: event?.detail?.razorpay_payment_id,
      razorpayOrderId: event?.detail?.razorpay_order_id,
      razorpaySignature: event?.detail?.razorpay_signature,
    };
    orderObj['studentId'] = this.userDetails?._id;
    orderObj['paymentId'] = this.currentInterview?.id;
    orderObj['referenceId'] = this.currentInterview?.referenceId;
    this.loading = true;
    this.razorPay.updateOrder(this.paymentVerifyDataModel, orderObj).subscribe((data: any) => {
      this.currentInterview = data;
      if (this.currentInterview?.paymentStatus === 'Paid') {
        let interviewCode = localStorage.getItem('visaCode');
        let updateObj: any;

        if (this.visamonkPermissions?.[this.puid]?.offerAvailable === true) {
          const offerCode = this.appliedOfferCode || this.currentInterview?.offerCode || '';
          const discountedPrice = this.discountedPricePaid || this.currentInterview?.amount || 0;
          const originalPrice = this.originalAmount || Number(this.partnerUidDetails?.company?.paymentAmountForMockVisa || 0);

          updateObj = {
            studentId: this.userDetails._id,
            isPaymentRelatedPartner: true,
            paymentStatus: 'Paid',
            offerCode: offerCode,
            discountedPricePaid: discountedPrice,
            originalAmount: originalPrice
          };

        }
        else {
          updateObj = {
            studentId: this.userDetails._id,
            isPaymentRelatedPartner: true,
            paymentStatus: 'Paid'
          };
        }



        this.apiHelper.updateData(this.updateLicenceModel, interviewCode, updateObj).subscribe((res: any) => {
          this.licenseDetails = { ...res.data };
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      } else {
        alert('Your Payment Status is Failed');
      }
    });
  }

  isPoweredByTextVisible(): boolean {
    return this.visamonkPermissions?.[this.puid]?.showPoweredByText === true;
  }

  openOfferCodePopup() {
    // Reset pricing display
    this.showDiscountedPrice = false;
    this.currentDiscountedPrice = 0;
    this.currentDiscountPercent = 0;

    this.setOfferCodeLayout();
    this.modalService.open(this.offerCodePopup, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });
  }


  setOfferCodeLayout() {
    // Get original price from partner details
    this.currentOriginalPrice = Number(this.partnerUidDetails?.company?.paymentAmountForMockVisa);

    this.offerCodeFields = [{
      fieldGroupClassName: "row text-secondary align-items-center custom-input",
      fieldGroup: [
        {
          className: 'col-12 mb-3',
          template: `<h1 class="text-primary-dark">Enter Offer Code</h1>`,
        },
        {
          key: 'offerCode',
          type: 'input',
          className: "rounded rounded-1",
          templateOptions: {
            label: 'Enter your offer code to get discount!',
            placeholder: 'Enter offer code',
            required: true
          },
          hooks: {
            onInit: (field: any) => {
              // Watch for changes in the field value
              field.formControl.valueChanges.subscribe((value: string) => {
                this.onOfferCodeChange(value || '');
              });
            }
          }
        },
        {
          className: 'col-12',
          template: `<p class="text-danger">Invalid offer code. Please check and try again.</p>`,
          hideExpression: () => {
            if (this.offerCodeValidationMessage === true) {
              return false;
            }
            return true;
          }
        },
        {
          className: 'col-12',
          template: `<p class="text-success">Offer code applied successfully!</p>`,
          hideExpression: () => {
            if (this.offerCodeSuccessMessage === true) {
              return false;
            }
            return true;
          }
        },
        {
          className: 'col-12 mb-0',
          template: `<ul class="text-muted text-smaller px-3">
            <li>Enter a valid offer code to get discount on your payment.</li>
            <li>Offer codes are case-sensitive.</li>
            <li>Each offer code can only be used once.</li>
          </ul>`
        },
        {
          fieldGroupClassName: "d-flex justify-content-start custom-btn text-center",
          fieldGroup: [
            {
              className: "col-6 me-2 border-custom bg-danger",
              type: "button",
              templateOptions: {
                onClick: (ev: any) => {
                  this.closeOfferCodePopup();
                },
                btnType: "w-100",
                text: "Cancel",
              },
            },
            {
              className: "col-6 bg-primary-apply text-light",
              type: "button",
              templateOptions: {
                btnType: "Submit",
                text: "Apply Code",
              },
            }
          ]
        }
      ]
    }];
  }

  onOfferCodeChange(enteredCode: string) {

    if (!enteredCode || enteredCode.length < 3) {
      this.showDiscountedPrice = false;
      return;
    }

    const offers = this.partnerUidDetails?.company?.offers || [];
    const upperCaseCode = enteredCode.toUpperCase();


    const validOffer = offers.find(offer => offer.offerCode.toUpperCase() === upperCaseCode);

    if (validOffer) {
      this.currentDiscountPercent = validOffer.discountPercent;
      this.currentDiscountedPrice = this.currentOriginalPrice * (1 - this.currentDiscountPercent / 100);
      this.showDiscountedPrice = true;

      this.offerCodeValidationMessage = false;

      console.log('Discount calculated:', {
        originalPrice: this.currentOriginalPrice,
        discountPercent: this.currentDiscountPercent,
        discountedPrice: this.currentDiscountedPrice,
        showDiscountedPrice: this.showDiscountedPrice
      });
    } else {
      this.showDiscountedPrice = false;
    }
  }

  closeOfferCodePopup() {
    this.offerCodeModel = {};
    this.offerCodeValidationMessage = false;
    this.offerCodeSuccessMessage = false;
    this.showDiscountedPrice = false;
    this.currentDiscountedPrice = 0;
    this.currentDiscountPercent = 0;
    this.modalService.dismissAll();
  }

  onOfferCodeSubmit(ev: any) {
    if (!ev?.error && this.offerCodeModel?.offerCode) {
      this.offerCodeValidationMessage = false;
      this.offerCodeSuccessMessage = false;

      const offers = this.partnerUidDetails?.company?.offers || [];
      const enteredCode = this.offerCodeModel.offerCode.toUpperCase();

      const validOffer = offers.find(offer => offer.offerCode.toUpperCase() === enteredCode);

      if (validOffer) {
        this.offerCodeSuccessMessage = true;

        // Store the offer code BEFORE closing the popup
        const appliedCode = this.offerCodeModel.offerCode;

        setTimeout(() => {
          this.closeOfferCodePopup();
          this.proceedWithDiscountedPayment(validOffer, appliedCode);
        }, 2000);
      } else {
        this.offerCodeValidationMessage = true;
        let newModel = { ...this.offerCodeModel };
        this.offerCodeModel = undefined;
        this.offerCodeModel = newModel;
      }
    }
  }

  proceedWithDiscountedPayment(validOffer: any, appliedCode: string) {
    const originalAmount = Number(this.partnerUidDetails?.company?.paymentAmountForMockVisa || 0);

    const discountPercent = validOffer.discountPercent;
    const discountedAmount = originalAmount * (1 - discountPercent / 100);

    this.appliedOfferCode = appliedCode;
    this.discountedPricePaid = Number(discountedAmount);
    this.originalAmount = originalAmount;

    let postObj = {
      studentId: this.userDetails.id,
      planId: 'paymentMockVisaLicence',
      currency: this.licenseDetails?.paymentCurrency,
      amount: Number(discountedAmount),
      paymentStatus: 'Initiated',
      puid: this.puid,
      receipt: this.userDetails.name,
      offerCode: appliedCode
    };

    if (this.userDetails?.parentId) {
      postObj['partnerId'] = this.userDetails.parentId;
    }
    if (this.userDetails?.parentUserId) {
      postObj['partnerId'] = this.userDetails.parentId;
      postObj['partnerUserId'] = this.userDetails.parentUserId;
    }

    this.razorPay.createOrder(this.paymentDataModel, postObj).subscribe((data: any) => {
      this.currentInterview = data;
      this.razorPay.openPaymentCheckout(
        data,
        this.visaService.studentDetails,
        'MockVisa'
      );
    },
      (error: any) => {
        console.info(error.error.message);
      }
    );
  }

  offerCodeDataProcessor(data: any) {
    return data;
  }

  // === Track user activity ===
  // private startActivityTracking() {
  //   const licenseNumber = sessionStorage.getItem('licenseNumber');

  //   if (!licenseNumber) {
  //     return;
  //   }

  //   // Send activity update immediately
  //   this.sendActivityUpdate(licenseNumber);

  //   // Track activity events
  //   const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

  //   const activityHandler = () => {
  //     const timeSinceLastSent = Date.now() - this.lastActivitySent.getTime();
  //     const threeMinutes = 3 * 60 * 1000;

  //     // Send update every 3 minutes of activity
  //     if (timeSinceLastSent > threeMinutes) {
  //       this.sendActivityUpdate(licenseNumber);
  //     }
  //   };

  //   // Add listeners
  //   events.forEach(event => {
  //     window.addEventListener(event, activityHandler);
  //   });

  //   // Also send periodic updates every 5 minutes
  //   this.activityInterval = setInterval(() => {
  //     this.sendActivityUpdate(licenseNumber);
  //   }, 5 * 60 * 1000);
  //   this.sessionCheckInterval = setInterval(() => {
  //     this.checkSessionValidity(licenseNumber);
  //   }, 2 * 60 * 1000);
  // }

  // === Send activity to backend ===
  // private sendActivityUpdate(licenseNumber: string) {
  //   this.apiHelper.postData('partner-licences/session/update-activity', {
  //     licenseNumber: licenseNumber
  //   }).subscribe({
  //     next: () => {
  //       this.lastActivitySent = new Date();
  //       console.log('Activity updated');
  //     },
  //     error: (error) => {
  //       console.error('Activity update failed:', error);
  //     }
  //   });
  // }

  // === Stop tracking ===
  // private stopActivityTracking() {
  //   if (this.activityInterval) {
  //     clearInterval(this.activityInterval);
  //   }
  //   if (this.sessionCheckInterval) {
  //     clearInterval(this.sessionCheckInterval);
  //   }
  // }

  private performLogout() {
    // this.stopActivityTracking();
    sessionStorage.removeItem('licenseNumber');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('decodedToken');
    localStorage.removeItem('visaCode');

    if (this.puid) {
      this.route.navigate(['/' + this.puid]);
    } else {
      this.route.navigate(['/']);
    }
  }

  // private checkSessionValidity(licenseNumber: string) {
  //   this.apiHelper.getData(`partner-licences/session/validate/${licenseNumber}`)
  //     .then((res: any) => {
  //       if (!res.isValid) {
  //         this.autoLogout();
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Session validation failed:', error);
  //     });
  // }

  // private autoLogout() {
  //   const licenseNumber = sessionStorage.getItem('licenseNumber');

  //   if (licenseNumber) {
  //     this.apiHelper.postData('partner-licences/session/end-license', {
  //       licenseNumber: licenseNumber
  //     }).subscribe({
  //       next: () => {
  //         this.performLogoutWithMessage();
  //       },
  //       error: () => {
  //         this.performLogoutWithMessage();
  //       }
  //     });
  //   } else {
  //     this.performLogoutWithMessage();
  //   }
  // }

  // private performLogoutWithMessage() {
  //   this.stopActivityTracking();
  //   sessionStorage.clear();
  //   localStorage.removeItem('visaCode');

  //   this.apiHelper.openSnackBar('Your session has expired due to inactivity. Please login again.');

  //   if (this.puid) {
  //     this.route.navigate(['/' + this.puid]);
  //   } else {
  //     this.route.navigate(['/']);
  //   }
  // }

  // Detect browser/tab close
  // private addBrowserCloseDetection() {
  //   window.addEventListener('beforeunload', (event) => {
  //     // Only show popup if it's NOT an intentional reload
  //     if (!this.isIntentionalReload) {
  //       event.preventDefault();
  //       event.returnValue = '';
  //       return '';
  //     }
  //   });
  // }

  // Handle actual close and logout
  // @HostListener('window:unload', ['$event'])
  // unloadHandler(event) {
  //   // ✅ Check the flag first
  //   if (this.isIntentionalReload) {
  //     return; // Don't logout on intentional reload
  //   }

  //   const licenseNumber = sessionStorage.getItem('licenseNumber');

  //   if (licenseNumber) {
  //     const url = `${environment.pathapi}/partner-licences/session/end-license`;
  //     const data = JSON.stringify({ licenseNumber: licenseNumber });
  //     navigator.sendBeacon(url, new Blob([data], { type: 'application/json' }));
  //   }
  // }

  // ngOnDestroy() {
  //   this.stopActivityTracking();
  // }

  // =====================================================================
  // Coventry Interview Integration
  // =====================================================================

  startCoventryInterview(interview: any) {
    this.modalService.dismissAll();
    this.step = 'firstStep';

    const sourceOfFinding = this.visaInformation?.visaDetails?.visaFinancialStatus?.join(',');
    
    const body = {
      interviewId: this.visaInformation?.visaDetails?.interviewCode,
      studentId: this.userDetails?._id,
      studentName: this.userDetails?.name ? this.userDetails?.name : `${this.userDetails?.firstName} ${this.userDetails?.lastName}`,
      interviewType: interview?.roundKey,
      studentEmail: this.userDetails?.email,
      // study_plan: this.userDetails?.studyPlan || '',
      target_country: this.userDetails?.targetCountry,
      university: this.userDetails?.academicDetails?.university,
      target_degree: this.userDetails?.targetDegree,
      specialization: this.userDetails?.visaCourse,
      visa_slot_info: this.visaInformation?.visaDetails?.visaInterviewStatus,
      fresh_or_rejected_visa: this.visaInformation?.visaDetails?.visaStatus,
      source_of_funding: sourceOfFinding,
      visa_rejections_other_countries: this.visaInformation?.visaDetails?.rejectionVisaStatus,
      licenceNumber: this.visaInformation?.visaDetails?.interviewCode,
      years_experience: this.userDetails?.visaWorkExperience,
      country_of_citizenship: this.getCountryLabel(this.userDetails?.countryOfCitizenship),
      country_code: this.userDetails?.countryOfCitizenship,
      embassy_location: this.visaInformation?.visaDetails?.visaEmbassyLocation,
      version: 'v2',
      currentAttempt: interview?.remainingAttempts + 1,
      testLevel: this.extractAttemptNumber(interview?.title),
      type: this.extractDifficulty(interview?.title),
      category: 'Mock'
    };

    this.loadingCoventryIframe = true;
    this.http.post<any>(`${environment.coventryApiUrl}/v1/api/interviewList`, body).subscribe({
      next: (res: any) => {
        this.loadingCoventryIframe = false;
        if (!res?.success || !res?.data?.interviewLink) {
          this.apiHelper.openSnackBar('Failed to start interview. Please try again.');
          return;
        }
        // interviewLink from API already contains the correct Coventry URL with token and attempt params
        let interviewLink = res.data.interviewLink;

        // TEMP: for local testing only, redirect to local Coventry instance
        // interviewLink = interviewLink.replace(
        //   'https://visa-monk.bookinterview.co.uk',
        //   'http://localhost:4000'
        // );

        this.coventryOrigin = new URL(interviewLink).origin;
        this.coventryIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(interviewLink);
        this.showCoventryIframe = true;
        this.setupCoventryMessageListener(interview);
      },
      error: () => {
        this.loadingCoventryIframe = false;
        this.apiHelper.openSnackBar('Network error. Please try again.');
      },
    });
  }

  onCoventryIframeLoad(iframeEl: HTMLIFrameElement) {
    if (this.coventryPayload) {
      iframeEl.contentWindow?.postMessage(this.coventryPayload, this.coventryOrigin);
    }
  }

  private setupCoventryMessageListener(interview: any) {
    this.teardownCoventryMessageListener();

    this.coventryMessageListener = (event: MessageEvent) => {
      console.log('[Coventry] message received — origin:', event.origin, '| data:', event.data);

      if (event.origin !== this.coventryOrigin) {
        console.warn('[Coventry] origin mismatch — expected:', this.coventryOrigin, '| got:', event.origin);
        return;
      }

      const { type, payload } = event.data || {};

      switch (type) {
        case COVENTRY_INBOUND_EVENTS.INTERVIEW_COMPLETED:
          this.onCoventryInterviewCompleted();
          break;

        case COVENTRY_INBOUND_EVENTS.INTERVIEW_CLOSED:
          this.onCoventryInterviewClosed();
          break;

        case COVENTRY_INBOUND_EVENTS.INTERVIEW_FAILED:
          this.onCoventryInterviewFailed(payload, interview);
          break;

        case COVENTRY_INBOUND_EVENTS.REQUEST_CANDIDATE_DATA:
          this.resendDataToCoventry();
          break;
      }
    };

    window.addEventListener('message', this.coventryMessageListener);
  }

  private resendDataToCoventry() {
    const iframe = document.getElementById('coventry-iframe') as HTMLIFrameElement;
    if (iframe?.contentWindow && this.coventryPayload) {
      iframe.contentWindow.postMessage(this.coventryPayload, this.coventryOrigin);
    }
  }

  private onCoventryInterviewCompleted() {
    try {
      this.visaService.resetBeforeUnload();
      this.teardownCoventryMessageListener();
      this.showCoventryIframe = false;
      localStorage.setItem('goBackToDashboard', 'my-tests');
      // NOTE: this.puid always mirrors the :puid param of the CURRENT route (set once in
      // ngOnInit from activatedRoute.snapshot.params), and this component only ever lives at
      // overall-dashboard[/:puid] — so the page location.reload() below fetches is already the
      // right one. A Router.navigate() call here would race location.reload() and never win
      // (its Promise can't resolve before the remaining synchronous statements finish), so it's
      // intentionally omitted rather than left in as dead code.
      this.forceReloadDashboard('onCoventryInterviewCompleted');
    } catch (err) {
      console.error('[Coventry] onCoventryInterviewCompleted failed before reload:', err);
    }
  }

  private onCoventryInterviewClosed() {
    try {
      this.visaService.resetBeforeUnload();
      this.teardownCoventryMessageListener();
      this.showCoventryIframe = false;
      localStorage.setItem('goBackToDashboard', 'my-tests');
      this.forceReloadDashboard('onCoventryInterviewClosed');
    } catch (err) {
      console.error('[Coventry] onCoventryInterviewClosed failed before reload:', err);
    }
  }

  private onCoventryInterviewFailed(payload: any, interview: any) {
    try {
      this.teardownCoventryMessageListener();
      this.showCoventryIframe = false;
      localStorage.setItem('goBackToDashboard', 'my-tests');
      this.forceReloadDashboard('onCoventryInterviewFailed', payload);
    } catch (err) {
      console.error('[Coventry] onCoventryInterviewFailed failed before reload:', err);
    }
  }

  // Shared reload path. The native "Reload site?" confirmation the browser shows here isn't
  // a scripted beforeunload handler (none is registered anywhere in this app) — it's Chrome's
  // built-in protection for an active camera/mic/screen-share recording. showCoventryIframe =
  // false only marks the *ngIf for removal on Angular's next change-detection tick, which hasn't
  // run yet by the time location.reload() fires on the next line — so the iframe (and the live
  // getUserMedia/getDisplayMedia tracks the Coventry app inside it is using) is still attached
  // to the DOM at reload time, and the browser blocks the reload behind that dialog to avoid
  // silently dropping an active recording. Removing the iframe node synchronously ourselves,
  // instead of waiting on Angular's async removal, tears down its browsing context (and those
  // tracks) immediately, so there's nothing live left for the browser to warn about.
  private forceReloadDashboard(tag: string, extra?: any): void {
    console.info(`[Coventry] ${tag} — reloading dashboard`, extra ?? '');
    (window as any).onbeforeunload = null;

    document.getElementById('coventry-iframe')?.remove();

    const watchdog = setTimeout(() => {
      console.warn(
        `[Coventry] ${tag} — location.reload() was called 2000ms ago but the page is still here. ` +
        `Check for a native "leave site?" browser-chrome dialog (not a page element) still blocking it.`
      );
    }, 2000);
    window.addEventListener('pagehide', () => clearTimeout(watchdog), { once: true });

    location.reload();
  }

  private teardownCoventryMessageListener() {
    if (this.coventryMessageListener) {
      window.removeEventListener('message', this.coventryMessageListener);
      this.coventryMessageListener = null;
    }
  }

  // Extracts the attempt number from title e.g. "Mock - 2 Easy" → 2
  private extractAttemptNumber(title: string): number {
    if (!title) return 1;
    const match = title.match(/Mock\s*-\s*(\d+)/i);
    return match ? Number(match[1]) : 1;
  }

  // Extracts the difficulty from title e.g. "Mock - 1 Easy" → "Easy"
  private extractDifficulty(title: string): string {
    if (!title) return 'Easy';
    const match = title.match(/(Easy|Medium|Hard)/i);
    return match ? match[1] : 'Easy';
  }

  ngOnDestroy() {
    this.teardownCoventryMessageListener();
  }

  // =====================================================================

}